<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <form @submit="onsubmit">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
        style="color:black!important"
      />

      <va-input
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />

      <div class="auth-layout__options d-flex align--center justify--space-between">
        <!-- <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/> -->
        <!-- <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link> -->
      </div>
      <h6 style="color:red;">{{msg}}</h6>
      <div class="d-flex justify--center mt-3">
        <button type="submit"  class="pl-4 pr-4 pt-2 pb-2" style="border-radius:16px;background-color:#F5F8F9!important">{{ $t('auth.login') }}</button>
      </div>

      <br />
    </form>
  </div>
</template>

<script>
import store from '../../../store'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'login',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      visible: false,
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
      message: '',
      msg: '',
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit (evt) {
      this.visible = true
      this.emailErrors = this.email ? [] : ['email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      // if (!this.formReady) {
      //   return
      // }
      // this.$router.push({ name: 'dashboard' })
      var data = {}
      data['email'] = this.email
      data['password'] = this.password

      // console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/admin/signin',
        data: data,
      })
        .then(response => {
          this.visible = false
          this.status = response.data.status
          this.msg = response.data.msg

          if (this.status === true) {
            store.commit('loginUser')
            console.log("first",response.data.userType)
            this.$store.commit("userData", response.data.data);
            store.commit('userType',response.data.usertype)
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('userType', response.data.usertype)
            localStorage.setItem('userName', response.data.username)
            // localStorage.setItem("email", response.data.data.email);
            console.log(response)
            this.$router.push({ path: '/dashboard' })
          } else {
            this.msg = 'Email/Password is incorrect'
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.data.status === false) { this.msg = 'Email/Password is incorrect' }
        })
    },
  },
}
</script>

<style lang="scss">
.va-input__container__label
{
  color:black!important
}
</style>
